module.exports = __webpack_public_path__ + "site/img/footeren.c92c5353.png";